import React, { useEffect, useState } from "react";
import OuraNav from "../components/OuraNav";
import fetchBase from "../utils/fetchBase";
import OigPreview from "../components/OigPreview";

export default function SecurityPage() {
    const authHeader = "Bearer " + localStorage.getItem("jwt_token");
    const [completedChecks, setCompletedChecks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [canRunThisMonth, setCanRunThisMonth] = useState(true);
    const [showNameModal, setShowNameModal] = useState(false);
    const [searcherFirstName, setSearcherFirstName] = useState("");
    const [searcherLastName, setSearcherLastName] = useState("");
    const [running, setRunning] = useState(false);
    const [previewData, setPreviewData] = useState(null);

    const startRun = async () => {
        setShowNameModal(false);
        setRunning(true);
        try {
            const res = await fetch(`${fetchBase}/api/security/oig-checks/run`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: authHeader },
                body: JSON.stringify({ searcherFirstName, searcherLastName })
            });
            const data = await res.json();
            if (res.ok) {
                setPreviewData(data);
            } else {
                alert(data.error || "Failed to run OIG check.");
            }
        } catch (err) {
            console.error("Run OIG check failed:", err);
            alert("Failed to run OIG check.");
        } finally {
            setRunning(false);
        }
    };

    useEffect(() => {
        fetch(`${fetchBase}/api/security/oig-checks`, { headers: { Authorization: authHeader } })
            .then(res => res.json())
            .then(data => {
                setCompletedChecks(Array.isArray(data.completed) ? data.completed : []);
                setCanRunThisMonth(data.canRunThisMonth !== false);
            })
            .catch(err => console.error("Failed to fetch OIG checks:", err))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div style={{ minHeight: "100vh", background: "#f5f5f7" }}>
            <OuraNav links={[{ label: "Dashboard", href: "/admin-dashboard" }]} />
            <div style={{ maxWidth: "800px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <h1 style={{ fontSize: "28px", fontWeight: "700", color: "#1d1d1f", marginBottom: "24px" }}>Security</h1>

                <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: "14px", padding: "24px", marginBottom: "30px" }}>
                    <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#1d1d1f", margin: "0 0 8px" }}>OIG</h2>
                    <p style={{ fontSize: "13px", color: "#6e6e73", margin: "0 0 16px" }}>
                        Runs a combined Federal (HHS-OIG) and Texas State (HHSC-OIG) exclusion search against every employee. Limited to one run per calendar month.
                    </p>

                        {loading ? (
                            <p style={{ fontSize: "13px", color: "#6e6e73" }}>Loading...</p>
                        ) : canRunThisMonth ? (
                            <button
                                onClick={() => setShowNameModal(true)}
                                disabled={running}
                                style={{ background: running ? "#a0c4e8" : "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "10px 20px", fontSize: "14px", fontWeight: 600, cursor: running ? "default" : "pointer" }}
                            >
                                {running ? "Running..." : "Run OIG"}
                            </button>
                        ) : (
                        <p style={{ fontSize: "13px", color: "#ff9500", fontWeight: 600 }}>
                            An OIG check has already been run this month. The next check will be available next month.
                        </p>
                    )}
                </div>

                <div style={{ background: "#fff", border: "1px solid #e0e0e0", borderRadius: "14px", padding: "24px" }}>
                    <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#1d1d1f", margin: "0 0 16px" }}>Completed</h2>
                    {completedChecks.length === 0 ? (
                        <p style={{ fontSize: "13px", color: "#6e6e73" }}>No completed checks yet.</p>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {completedChecks.map(check => (
                                <div key={check.id}
                                    onClick={() => window.location.href = `/account/security/oig-checks/${check.id}`}
                                    style={{
                                        background: "#fafafa", border: "1px solid #eee", borderRadius: "10px",
                                        padding: "12px 16px", display: "flex", justifyContent: "space-between", alignItems: "center",
                                        cursor: "pointer"
                                    }}>
                                    <span style={{ fontSize: "13px", fontWeight: 600, color: "#1d1d1f" }}>{check.monthLabel}</span>
                                    <span style={{ fontSize: "12px", color: "#6e6e73" }}>Completed {check.completedDate}</span>
                                </div>
                            ))}
                        </div>
                    )}
                        </div>

                        {showNameModal && (
                            <div style={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10000 }}>
                                <div style={{ background: "#fff", borderRadius: "14px", padding: "24px", width: "340px" }}>
                                    <p style={{ fontWeight: 700, fontSize: "15px", margin: "0 0 16px", color: "#1d1d1f" }}>Person Completing Search</p>
                                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#1d1d1f", display: "block", marginBottom: "12px" }}>
                                        First Name
                                        <input
                                            style={{ width: "100%", padding: "8px 10px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "8px", marginTop: "4px" }}
                                            value={searcherFirstName}
                                            onChange={e => setSearcherFirstName(e.target.value)}
                                        />
                                    </label>
                                    <label style={{ fontSize: "12px", fontWeight: 600, color: "#1d1d1f", display: "block", marginBottom: "16px" }}>
                                        Last Name
                                        <input
                                            style={{ width: "100%", padding: "8px 10px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "8px", marginTop: "4px" }}
                                            value={searcherLastName}
                                            onChange={e => setSearcherLastName(e.target.value)}
                                        />
                                    </label>
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                                        <button onClick={() => setShowNameModal(false)}
                                            style={{ background: "#f5f5f7", color: "#1d1d1f", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}>
                                            Cancel
                                        </button>
                                        <button onClick={startRun} disabled={!searcherFirstName || !searcherLastName}
                                            style={{ background: (!searcherFirstName || !searcherLastName) ? "#a0c4e8" : "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}>
                                            Run
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {previewData && (
                            <OigPreview
                                data={previewData}
                                onDiscarded={() => setPreviewData(null)}
                                    onConfirmed={() => {
                                        setPreviewData(null);
                                        setCanRunThisMonth(false);
                                        fetch(`${fetchBase}/api/security/oig-checks`, { headers: { Authorization: authHeader } })
                                            .then(res => res.json())
                                            .then(data => setCompletedChecks(Array.isArray(data.completed) ? data.completed : []))
                                            .catch(err => console.error("Failed to refresh completed checks:", err));
                                    }}
                            />
                        )}
                    </div>
                </div>
            );
        }